import React, { Component } from 'react'
import SerializeForm from 'form-serialize'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

// React Material Web Components
import { Grid, GridCell } from 'rmwc/Grid';
import { FormField } from 'rmwc/FormField';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Card } from 'rmwc/Card';

import { Typography } from 'rmwc/Typography';
import centaLogo from '../assets/images/centa-logo-new.png';
import { Button } from 'rmwc/Button';
import StatusMessage from '../util/StatusMessage'
import UserConfirmation from './UserConfirmation'
import ReactGA from 'react-ga';


class Signup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      successMsg: '',
      modal: false,
      formErrors: {
        phoneNumberError: '',
        passwordError: '',
        passwordConfirmationError:'',
        referralCodeError: '',
        emailError:'',
        userNameError: '',
      },
      userInfo: {
        accessToken: '',
        client: '',
        uid: '',
        email: '',
        id: '',
        role: '',
        userName: '',
        image: '',
        phone: '',
        countryCode: '91'
      },
      showOTPComponent: false,
      showEmailComponent: true,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.signupSuccess = this.signupSuccess.bind(this)
    this.checkForErrors = this.checkForErrors.bind(this)
    
  }

  componentDidMount() {
   ReactGA.initialize('UA-139837993-1');
   ReactGA.pageview('portal/signup'); 
  }

  onInputChange = evt => {
    const userInfo = Object.assign({}, this.state.userInfo);
    userInfo[evt.target.name] = evt.target.value;
    this.setState({userInfo});
  };

  checkForErrors(values){
    let error = false
    let errorObj = Object.assign({}, this.state.formErrors)

    errorObj.phoneNumberError =''
    errorObj.passwordError =''
    errorObj.passwordConfirmationError=''
    errorObj.referralCodeError = ''
    errorObj.emailError = ''
    errorObj.userNameError = ''

    if(values.phone === undefined){
      errorObj.phoneNumberError ='Mobile Number is mandatory'
      error = true
    }
    else{
      var phoneno = /^\d{7,22}$/;
      let fullPhoneNumber = values.countryCode+values.phone
      console.log(fullPhoneNumber)
      if(!fullPhoneNumber.match(phoneno)){
        errorObj.phoneNumberError ='Please enter a valid mobile number'
        error = true
      }
    }

    if(values.userName === undefined){
      errorObj.userNameError ='User Name is mandatory'
      error = true
    }

    if(values.password === undefined){
      errorObj.passwordError ='Password is mandatory'
      error = true
    }

    if(values.passwordConfirmation === undefined){
      errorObj.passwordConfirmationError ='Confirm Passowrd is mandatory'
      error = true
    }

    if(values.password !== values.passwordConfirmation){
      errorObj.passwordError = 'Password and Confirm password are not matching'
      error = true
    }

    if (values.usedReferralCode !== undefined && values.usedReferralCode.length > 8){
      errorObj.referralCodeError = 'Referral Code can only be 8 Characters long'
      error = true
    }

    if(values.countryCode !=='91'){
      if(values.email === undefined || values.email ===''){
        errorObj.emailError ='Email is mandatory when mobile number is Non-Indian'
        error = true
      }
      else{
        var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if(!pattern.test(values.email)){
          errorObj.emailError ='Invalid Email Format'
          error = true
        }
      }

    }

    this.setState({
      formErrors:errorObj,
      errorMsg:''
    })
    return error
  }

  handleSubmit(e) {
    e.preventDefault()
    
    const values = SerializeForm(e.target, { hash: true })
    let userInfo = Object.assign({}, this.state.userInfo)
    // console.log(values)
    const err = this.checkForErrors(values)
    values.phone = values.countryCode+values.phone
    const obj = {}

    if (!err) {
      api
        .signUp(values)
        .then((result) => {
          
          const { status, errors, data } = result
          if (status === 'error') {
            this.setState({ errorMsg: data })
          }
          if (status === 'success') {
            this.setState({ errorMsg: '' })
            
            if(data.active){
              obj.accessToken = result.headers.accessToken 
              obj.id = data.id
              obj.userName = data.userName
              obj.role = data.role
              
              this.props.userLogin(obj)
              //this.props.history.push('/portal/app/my_registrations')
              window.top.location.href = "/portal/app/welcome_page"
            }
            else{
              //this.props.history.push('/portal/confirm_registration')
              userInfo.userName = data.userName
              this.setState({showOTPComponent: true, userInfo: userInfo})
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.setState({ errorMsg: 'Error registering user' })
        })
    }
  }

  signupSuccess(obj) {
    console.log(obj)
    this.props.userLogin(obj)
    /*if (obj.role === 'user'){
      console.log('Inside user')
      this.props.userLogin(obj)
      
    } else if (obj.role === 'admin'){
      console.log('Inside admin')
      this.props.adminLogin(obj)
      //this.props.history.push(`/${obj.role}/admindashboard`)
    }*/
  }

  onRedirectPostLogin = (pwdChangeReqd) => {
    this.props.history.push('/portal/app/welcome_page')
  }

  render() {
    let displayComponent;
    let userName = this.state.userInfo.userName
    let emailComponent
    
    if((this.state.userInfo.countryCode !== '91') && !(this.state.showOTPComponent)){
      emailComponent = (<GridCell>
        <FormField style={{width: '100%'}}>
          <div className="login_icon">
            <TextFieldIcon use="email"/>
          </div>
          <TextField fullwidth label="Email for Non-Indian Users" autoComplete="off" name="email" className='email' />
        </FormField>
      </GridCell>)
    }

    if(this.state.showOTPComponent){
      displayComponent = (
        <Card style={{width: '22rem',padding: '25px'}}>
          <UserConfirmation userName={userName} onRedirectPostLogin={this.onRedirectPostLogin}/>
        </Card>
      )
    }
    
    else{
      displayComponent = (
        <form onSubmit={this.handleSubmit}>
          <Card style={{width: '22rem',padding: '25px'}}>
            <GridCell>
              <div style={{padding: '0 1rem 1rem 1rem'}}>
                <img src={centaLogo} alt="logo" />
                <Typography use="title" tag="h2">Signup</Typography>
                <Typography
                  use="subheading1"
                  tag="h3"
                  theme="text-secondary-on-background"
                  style={{marginTop: '-1rem'}}
                >
                </Typography>
              </div>
            </GridCell>
            <GridCell>
              <FormField style={{width: '100%'}}>
                <div className="login_icon">
                  <TextFieldIcon use="perm_identity"/>
                </div>
                <TextField fullwidth label="Username" autoComplete="off" name="userName" className='user_name' />
              </FormField>
            </GridCell>
            <GridCell>
              <FormField style={{width: '100%'}}>
                <div className="login_icon">
                  <TextFieldIcon use="phone"/>
                </div>
                <TextField  label="Code" autoComplete="off" name="countryCode" type="number" className='phone country-code' onChange={this.onInputChange} value={this.state.userInfo.countryCode} />
                <TextField fullwidth label="Mobile" autoComplete="off" name="phone" type="number" className='phone' />
              </FormField>
            </GridCell>
            <GridCell>
              <FormField style={{width: '100%'}}>
                <div className="login_icon">
                  <TextFieldIcon use="lock_outline"/>
                </div>
                <TextField fullwidth label="Password" type="password" name="password" className='password' />
              </FormField>
            </GridCell>
            <GridCell>
              <FormField style={{width: '100%'}}>
                <div className="login_icon">
                  <TextFieldIcon use="lock_outline"/>
                </div>
                <TextField fullwidth label="Confirm Password" type="password" name="passwordConfirmation" className='password' />
              </FormField>
            </GridCell>
            <GridCell>
              <FormField style={{width: '100%'}}>
                <div className="login_icon">
                  <TextFieldIcon use="record_voice_over"/>
                </div>
                <TextField fullwidth label="Referral Code(Optional)" autoComplete="off" name="usedReferralCode" className='user_name' />
              </FormField>
            </GridCell>
            {emailComponent}
            <GridCell className='submit-button'>
              <FormField>
                <Button raised>SIGN UP</Button>
              </FormField>
            </GridCell>
            <GridCell className='sign-up-link'>
              <Typography use="subheading2">Have an account? <Typography use="body1" tag="a" href="/portal/signin">Sign In.</Typography></Typography>
            </GridCell>
          </Card>
        </form>
      )
    }
    return (
      <div>
        <Grid className="signup-card">
          <GridCell span="4" align="middle"></GridCell>
          <GridCell className="align-center" span="4">
            {displayComponent}
            <StatusMessage 
            error_msg = {this.state.errorMsg}
            />
            <StatusMessage error_msg = {this.state.formErrors.phoneNumberError}/>
            <StatusMessage error_msg = {this.state.formErrors.passwordError}/>
            <StatusMessage error_msg = {this.state.formErrors.passwordConfirmationError}/>
            <StatusMessage error_msg = {this.state.formErrors.referralCodeError}/>
            <StatusMessage error_msg = {this.state.formErrors.emailError}/>
            <StatusMessage error_msg = {this.state.formErrors.userNameError}/>

          </GridCell>
          <GridCell span="4" align="middle"></GridCell>
        </Grid>
      </div>
    )
  }
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Signup)




// WEBPACK FOOTER //
// ./src/views/Signup.jsx